import { TiptapJson } from 'api/page-template/types';
import { FC, useMemo } from 'react';
import { useCurrentDocumentEditor } from 'components/organisms/company-page-template/editor-context';
import { DocumentEditor } from 'components/organisms/document-editor/document-editor';
import { PeoplePageDerivedSectionSourcesUpdater } from 'components/organisms/document-editor/extensions/custom-section/types';
import { ExtensionConfig } from 'components/organisms/document-editor/types';
import { useCommandsForPeoplePageTemplatePickerAsPromise } from './commands-for-editor';

interface Props {
  tiptapJson: TiptapJson;
  onChange: (tiptapJson: TiptapJson) => void;
  sectionSourceUpdater: PeoplePageDerivedSectionSourcesUpdater;
}
export const PeoplePageTemplateDocument: FC<Props> = ({
  tiptapJson,
  onChange,
  sectionSourceUpdater,
}) => {
  const { setEditor } = useCurrentDocumentEditor();
  const commandsForCommandPickerGetter =
    useCommandsForPeoplePageTemplatePickerAsPromise();

  const editorExtensionsConfig: Partial<ExtensionConfig> = useMemo(() => {
    return {
      customSectionConfig: {
        allowResolve: false as const,
        generateTemplateSectionId: true,
        peoplePageDerivedSectionSourcesUpdater: sectionSourceUpdater,
      },
      groupSectionConfig: {
        generateTemplateSectionId: true,
      },
      commandPickerWithTriggerConfig: {
        enabled: true,
        items: commandsForCommandPickerGetter,
      },
      endOfDocumentConfig: {
        enabled: true,
      },
    };
  }, [commandsForCommandPickerGetter, sectionSourceUpdater]);

  return (
    <DocumentEditor
      value={tiptapJson}
      onChange={onChange}
      onInitialize={(editor) => {
        setEditor(editor);
      }}
      floatingToolbarConfig={{
        enabled: false,
      }}
      extensionConfig={editorExtensionsConfig}
      canDragAndDrop={true}
    />
  );
};
